import React from 'react' 
import { Form, Button, Input, Icon } from 'antd'

 const MemberFilter = (props) => {

  return (
    <div className="panel">
      <Form layout="inline" onSubmit={props.sumbitFilter}>
        <Form.Item label="Filter">
          <Input prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Filter" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" shape="circle" icon="search" htmlType="submit"></Button>
        </Form.Item>
      </Form>
    </div>)
}

export default MemberFilter